export default "__VITE_ASSET__CNyiEsT7__"